import { render, staticRenderFns } from "./CompanyWhatIsMew.vue?vue&type=template&id=00336cf4"
import script from "./CompanyWhatIsMew.vue?vue&type=script&lang=js"
export * from "./CompanyWhatIsMew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports